import * as screens from '@core/layouts/components/menu/screens';
import paths from 'views/screens/Reports/paths';
import permissions from 'views/screens/Reports/permissions';
import Icon from '../../utility/icomoon';

export default [
  {
    id: 'reports',
    title: 'reports.reports',
    icon: <Icon size={20} icon="noun_report_556224" />,
    iconName: 'noun_report_556224',
    permissions: [
      permissions.systemCommunicationsDiagReport,
      permissions.systemNotificationsReport,
      permissions.accommodationChargesReport,
      permissions.mileageReport,
      permissions.hourMetersReport,
      permissions.consolidatedUnitActivityReport,
      permissions.consolidatedEventActivityReport,
      permissions.fuelSensorReport,
      permissions.consolidatedUnitActivityReport,
      permissions.parkedGeofenceReport,
      permissions.administrativeReports,
      permissions.byUnitReports,
      permissions.consolidatedReports,
      permissions.listReports,
      permissions.runningTimeReport,
      permissions.unitActivity,
      permissions.byUnitReports,
      permissions.consumptionAPIReport,
      permissions.readWebEvents,
      permissions.scheduledReports
    ],
    navLink: paths.reportList,
    screenId: screens.REPORTS
    //children: [...scheduledReports, ...consolidated, ...byUnit, ...system]
  }
];
